const DEVICE_ID_KEY = 'checkinDeviceId'

/**
 * OC-448: a stable per-browser/device id, shared same-origin between the Core app's check-in widget
 * and the public barcode lobby page (they share localStorage on the same origin). The barcode scanner
 * writes to THIS device's Firestore doc, and only the session holding this id reacts — so a barcode
 * scan pops the widget for the operating device only, never every staff member at the site.
 */
export const getCheckinDeviceId = (): string | null => {
  try {
    let id = window.localStorage.getItem(DEVICE_ID_KEY)
    if (!id) {
      id =
        window.crypto?.randomUUID?.() ?? `dev-${Date.now()}-${Math.random().toString(36).slice(2)}`
      window.localStorage.setItem(DEVICE_ID_KEY, id)
    }
    return id
  } catch {
    return null
  }
}
